import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { registerPlugin } from "@capacitor/core";
import axios from 'axios';

var options = {
    environment: "sandbox",
    logo: "https://www.financialexpress.com/wp-content/uploads/2022/02/Chola.jpg?w=350",
};

/**
 * * Digimandate Sdk Integration => repayment setup
 * @param Mid -> mandate id
 * @param identifier -> user identifier
 * @param leadId -> d2c id
 */
export const Digimandate = ({ Mid, identifier, lead_id, gwt, setReqData }) => {
    // const platform = 'web'
    const { vertical } = useSelector((state) => state.mandateInfo)
    const { enqueueSnackbar } = useSnackbar();

    // Digimandate callback

    // const invokeDigimandateSdk = async () => {
    //     // dispatch(toggleLoading(true));
    //     try {
    //         const Digio = registerPlugin("Digilocker");
    //         await Digio.digioKyc({
    //             docId: Mid,
    //             identifier,
    //             gwt,
    //             env: "sandbox",
    //         });
    //         // await dispatch(eNachRes({ lead_id, mandate_id: Mid })).unwrap();
    //     } catch (error) {
    //         // dispatch(cloudWatchApiLog({ message: error }));
    //         enqueueSnackbar("Error from mandate. Please try again", {
    //             variant: "warning",
    //             preventDuplicate: true,
    //         });
    //     }
    //     // dispatch(toggleLoading(false));
    // };

    const invokeFlutter = async () => {
        const digiores = await window.flutter_inappwebview.callHandler(
            "validatedigioaadhar",
            lead_id,
            Mid,
            identifier,
            gwt
        );
        if (digiores?.res?.error && digiores?.res?.error?.length) {
            setReqData(false)
            // return console.log("error occurred in process");
            throw new Error(digiores?.res?.error);
        }
        let data = {
            mandate_id: Mid,
        }
        axios({
            url: process.env.REACT_APP_DIGIO_RES,
            method: 'post',
            headers: {
                "Access-Control-Allow-Origin": "*",
                'Authorization': process.env.REACT_APP_API_KEY
            },
            data: data
        }).then((res) => {
            if (res?.data?.message === "Success") {
                window.location.assign(res?.data?.redirect_url)
            }
            else {
                setReqData(false)
            }
        })

    }

    const invokeDigimandateWeb = async () => {
        options["callback"] = (response) => {
            // dispatch(toggleLoading(false));
            if (response.hasOwnProperty("error_code")) {
                setReqData(false)
                return console.log("error occurred in process");
            }
            let data = {
                mandate_id: Mid,
            }
            axios({
                url: process.env.REACT_APP_DIGIO_RES,
                method: 'post',
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': process.env.REACT_APP_API_KEY
                },
                data: data
            }).then((res) => {
                if (res?.data?.message === "Success") {
                    window.location.assign(res?.data?.redirect_url)
                }
                else {
                    setReqData(false)
                }
            })
            // dispatch(eNachRes({ lead_id, mandate_id: Mid }));
        };

        try {
            var digio = new window.Digio(options);
            digio.init();
            digio.submit(Mid, identifier, gwt);
            // digio.submit("KID2210150009166422FMMOPG5O8M8Y9", "9047757545");
        } catch (error) {
            // dispatch(toggleLoading(false));
            // enqueueSnackbar("Error from mandate. Please try again", {
            //     variant: "warning",
            //     preventDuplicate: true,
            // });
            return enqueueSnackbar("Error from mandate. Please try again", {
                variant: "error",
                autoHideDuration: 3000,
                preventDuplicate: true,
            });
        }
    };

    useEffect(() => {
        if (Mid && identifier) {
            if (vertical === "flutter") {
                // invokeDigimandateWeb();
                invokeFlutter()
            }
            else {
                invokeDigimandateWeb()
            }
            // else {
            //     invokeDigimandateSdk();
            // }
        }
    }, []);

    return <></>;
};
